import { errorMessage } from './model'

export function resource() {
  return { data: null, loading: false, error: '', request: 0 }
}

export default {
  beforeCreate() {
    this.workspaceAlive = true
  },
  beforeDestroy() {
    this.workspaceAlive = false
  },
  methods: {
    async loadResource(target, request, retainData = false) {
      const revision = ++target.request
      target.loading = true
      target.error = ''
      if (!retainData) target.data = null
      try {
        const { data } = await request()
        if (!this.workspaceAlive || revision !== target.request) return false
        target.data = data
        return true
      } catch (error) {
        if (this.workspaceAlive && revision === target.request) target.error = errorMessage(error)
        return false
      } finally {
        if (this.workspaceAlive && revision === target.request) target.loading = false
      }
    }
  }
}
